import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=ff51ed6e&scoped=true&"
import script from "./sobre.vue?vue&type=script&lang=js&"
export * from "./sobre.vue?vue&type=script&lang=js&"
import style0 from "./sobre.vue?vue&type=style&index=0&id=ff51ed6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff51ed6e",
  null
  
)

export default component.exports